/**
 * Tenant-scoped directory for workspace pickers (BFF: GET /directory/tenant-users).
 */

import { tenantApiFetch, tenantDashboardPath } from "@/lib/tenantApi";

const TENANT_USERS_PATH = tenantDashboardPath("/directory/tenant-users");

export class TenantWorkspaceDirectoryClient {
  /**
   * @returns {Promise<{ data: { users: Array<{ id: string, name: string, email: string }> } }>}
   */
  async listUsers() {
    const data = await tenantApiFetch(TENANT_USERS_PATH);
    const users = (data.users || []).map((u) => ({
      id: String(u.id || ""),
      name: String(u.name || ""),
      email: String(u.email || ""),
    }));
    return { data: { users } };
  }
}

export const tenantWorkspaceDirectoryClient = new TenantWorkspaceDirectoryClient();

/** @returns {Promise<{ data: { users: Array<{ id: string, name: string, email: string }> } }>} */
export async function listTenantWorkspaceDirectoryUsers() {
  return tenantWorkspaceDirectoryClient.listUsers();
}
